/*
 * Efizi · Realoca o seletor de região pro topo do header (ao lado do logo),
 * espelhando o mockup aprovado. O tema nativo renderiza a região dentro da
 * barra separada de baixo (.header-separated-menu); aqui a gente move esse
 * nó pra dentro do .header do topo. A versão de baixo fica escondida por CSS
 * (no snippet efizi-mini-header), então os departamentos colam na margem
 * esquerda. Em telas < 990px nada disso roda de fato pra layout (o CSS
 * esconde), e o mobile continua usando a seção region-bar própria.
 */
(function () {
  function relocate() {
    var header =
      document.querySelector('.section-header .header') ||
      document.querySelector('header.header');
    if (!header) return;
    if (header.querySelector('.efizi-header-region')) return; // já feito

    var sep = document.querySelector('.header-separated-menu');
    if (!sep) return;

    var region = sep.querySelector('.header-saparated-menu__region');
    if (!region) return;

    var wrap = document.createElement('div');
    wrap.className = 'efizi-header-region';
    wrap.appendChild(region); // move o nó (sai da barra de baixo)

    var heading =
      header.querySelector(':scope > .header__heading') ||
      header.querySelector(':scope > .header__heading-link');

    if (heading) {
      heading.insertAdjacentElement('afterend', wrap);
    } else {
      header.insertBefore(wrap, header.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocate);
  } else {
    relocate();
  }
})();
